function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon / Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/today_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 2.66671H12V2.00004C12 1.63337 11.7 1.33337 11.3333 1.33337C10.9667 1.33337 10.6667 1.63337 10.6667 2.00004V2.66671H5.33333V2.00004C5.33333 1.63337 5.03333 1.33337 4.66667 1.33337C4.3 1.33337 4 1.63337 4 2.00004V2.66671H3.33333C2.59333 2.66671 2.00667 3.26671 2.00667 4.00004L2 13.3334C2 14.0667 2.59333 14.6667 3.33333 14.6667H12.6667C13.4 14.6667 14 14.0667 14 13.3334V4.00004C14 3.26671 13.4 2.66671 12.6667 2.66671ZM12.6667 12.6667C12.6667 13.0333 12.3667 13.3333 12 13.3333H4C3.63333 13.3333 3.33333 13.0333 3.33333 12.6667V6H12.6667V12.6667ZM7.33333 7.33333H5.33333C4.96667 7.33333 4.66667 7.63333 4.66667 8V10C4.66667 10.3667 4.96667 10.6667 5.33333 10.6667H7.33333C7.7 10.6667 8 10.3667 8 10V8C8 7.63333 7.7 7.33333 7.33333 7.33333Z",
    fill: props.fill
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.a2cd6dc3297b4c9d46e8e3261ec0d888.svg";
export { ForwardRef as ReactComponent };